import client from '../httpClient';

const actPutHistoryApi = (pathParameter, params) => {
  return client.put(`/actions/histories/${pathParameter}`, JSON.stringify(params), { isShowLoading: false });
};

export default actPutHistoryApi;
